/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tb_LeadInputs */

const en_mk_tb_lead = /** @type {(inputs: Mk_Tb_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build with your cofounder and developers. Give each task a human owner, let everyone use their own coding tool, and follow the evidence, blockers and reviews in Bystep.`)
};

const id_mk_tb_lead = /** @type {(inputs: Mk_Tb_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build bersama cofounder dan developer Anda. Tentukan penanggung jawab setiap tugas, gunakan alat coding pilihan masing-masing, lalu pantau bukti, hambatan, dan review lewat Bystep.`)
};

/**
* | output |
* | --- |
* | "Build with your cofounder and developers. Give each task a human owner, let everyone use their own coding tool, and follow the evidence, blockers and reviews..." |
*
* @param {Mk_Tb_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tb_lead = /** @type {((inputs?: Mk_Tb_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tb_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tb_lead(inputs)
	return en_mk_tb_lead(inputs)
});